import { render } from "./PlpSpellingSuggestion.vue?vue&type=template&id=0bcb319e"
import script from "./PlpSpellingSuggestion.vue?vue&type=script&lang=js"
export * from "./PlpSpellingSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__